import styled from 'styled-components';

export const Wrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 40px;
    @media(max-width: 900px){
        padding-top: 0px;
    }
    @media(max-width: 768px){
        overflow-x: hidden;
    }
    @media(max-width: 500px){
        padding: 0 15px;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: ${props => props.margin || '0'};
`

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: ${props => props.alignItems || 'stretch'};
    justify-content: ${props => props.justifyContent || 'flex-start'};
    margin: ${props => props.margin || '0'};
    width: ${props => props.autoWidth ? 'auto' : '100%'};
    flex-direction: ${props => props.flexDirection ? props.flexDirection : 'row'};
`

export const Col = styled.div`
    display: flex;
    flex: ${props => props.size ? `0 0 ${props.size}` : '0 1 auto'};
    margin: ${props => props.margin || '0'};
    ${props => props.order && `order: ${props.order}`};
    ${props => props.alignSelf && `align-self:${props.alignSelf}`};
    ${props => props.alignItems && `align-items:${props.alignItems}`};
    ${props => props.justifyContent && `justify-content:${props.justifyContent}`};
    ${props => props.flexDirection && `flex-direction:${props.flexDirection}`};
`
